import React from 'react';
import './Game.css';

import { renderIcon } from '../../utils';

import { Link } from 'react-router-dom';

const Game = ({game}) => {

  // Destructuring props to extract the necessary details for each game
  const { id, image, title, content, logo } = game;

  return (

    <div className='game-item' key={id}>

      <img src={image} alt={title} />{/* Service Image */}

      <div className='content'>

        <div className='intro'>
       
         {/* Link to the individual game page */}
         <Link
          to={{ 
            pathname: '/Games/' + title,  // Navigate to the specific game page
          }}
          location = {{game}}  // Passing game details to the linked page
          state= {game}> 
           <img src={logo} className='logo' alt={title} />
        </Link>
          {/* <div className='icon'>{renderIcon(title)}</div>  */}
          {/* Display the service icon based on title */}
          {/* <h6>0{id}</h6> */}
        </div>

        {/* <p>{content}</p>  */}
        {/* Game Description */}

        {/* Read more link to navigate to the full service page */}
        {/* <Link
          to={{ 
            pathname: '/Games/' + title,  // Navigate to the specific service page
          }}
          location = {{game}}  // Passing service details to the linked page
          className='btn'  // Apply button style
          state= {game}>Read More
        </Link>  Button to read more about the service */}

      </div>

    </div>

  );
};

export default Game;